export const DATE_FORMAT = 'DD-MM-YYYY'
export const WESTPARK = 'WESTPARK'

export const CUSTOMER_TYPE_INDIVIDUAL = 'CPF'
export const CUSTOMER_TYPE_BUSINESS = 'CPNJ'
